import PropTypes from 'prop-types';
import React from 'react';
import CornerMark from './CornerMark';

const propTypes = {
  direction: PropTypes.oneOf(['topleft', 'topright']),
};

const defaultProps = {
  direction: 'topleft',
};

function CheckMark({ direction }) {
  return (
    <CornerMark icon="checkmark" direction={direction} kind="primary" />
  );
}

CheckMark.propTypes = propTypes;
CheckMark.defaultProps = defaultProps;

export default CheckMark;
